import React from 'react';
import { Table, UncontrolledTooltip, Alert, Button, Row, Col } from 'reactstrap';
import moment from 'moment/min/moment-with-locales';
import * as utils from '../../Services/utils';
import { withRouter } from 'react-router-dom';
import { InfoTag } from '../shared/infoTag';
import ApplicationButtons from '../shared/applicationButtons';
import * as HelpMessages from '../../Services/helpMessages';
import swal from 'sweetalert';
import { withTranslation, Trans } from 'react-i18next';
import AssignedUserModal from '../../Components/Modals/assignedUserModal';
import { downloadDocument } from '../../Helpers/applicantHelper';
import {
  renderSuccessPercentage,
  composeApplicationType as composeApplicationType,
} from '../../Helpers/applicantHelper';
import { getUsers } from '../../Services/userService';
import { updateApplicationStatus } from '../../Services/applicationService';
import { basicDateFormat } from '../../Helpers/dateTimeHelper';
import { AssignedUserType } from '../../Components/Modals/assignedUserModal';

class ApplicationsTable extends React.Component {
  state = {
    fileName: 'applicationDetails.jpg',
    showModal: false,
    application: {},
  };

  async goToApplication(application) {
    this.props.history.push(`/applications/details?applicationId=${application.applicationId}&tab=applicationDetails`);

    if (application?.isNew) {
      await this.dispatch.decreaseNumNewApplications();
    }
  }

  deleteApplication = (application) => {
    const { t } = this.props;
    swal({
      title: t('applications.DELETE_APPLICATION_TITLE'),
      text: t('applications.DELETE_APPLICATION_TEXT'),
      icon: 'warning',
      buttons: {
        cancel: {
          text: t('common.CANCEL'),
          value: null,
          visible: true,
          closeModal: true,
        },
        confirm: {
          text: t('common.DELETE'),
          value: true,
          visible: true,
          closeModal: true,
        },
      },
      dangerMode: true,
    }).then((willArchive) => {
      if (willArchive) {
        updateApplicationStatus(application.applicationId, 'Deleted').then((response) => {
          this.props.refreshStatus();
        });
      }
    });
  };

  toggle = (application) => {
    this.setState({ showModal: !this.state.showModal, application: application });
  };

  refreshStatus(application, newStatus) {
    this.props.refreshStatus(application, newStatus);
  }

  render() {
    const { t } = this.props;
    return (
      <>
        {this.props.applications.length > 0 ? (
          <>
            <AssignedUserModal
              showModal={this.state.showModal}
              onToggle={(application) => this.toggle(application)}
              onStatusRefresh={() => this.refreshStatus()}
              application={this.state.application}
              assignedUserType={AssignedUserType.AssignedToApplication}
            />
            <div style={{ overflowX: 'auto', width: '100%' }}>
              <Table striped bordered style={{ minWidth: '800px' }}>
                <thead>
                  <tr>
                    <th style={{ width: '60px' }}></th>
                    <th hidden>Application Id</th>
                    <th>
                      <Trans i18nKey="common.FIRST_NAME" />
                      {', '}
                      <Trans i18nKey="common.LAST_NAME" />
                      {', '}
                      <Trans i18nKey="common.E_MAIL" />
                    </th>
                    <th>
                      <Trans i18nKey="common.STATUS" />
                    </th>
                    <th>
                      <Trans i18nKey="applications.APPLIED_FOR" />
                    </th>
                    <th style={{ width: '35px' }}>CV</th>
                    <th>
                      <Trans i18nKey="applications.APPLICATION_TYPE" />
                      &nbsp;
                      <InfoTag id="allApplications" lng={this.props.i18n.language}></InfoTag>
                    </th>
                    <th>
                      <Trans i18nKey="applications.JOB_FIELD" />
                    </th>
                    <th>
                      <Trans i18nKey="applications.JOB_TYPE" />
                      &nbsp;
                      <InfoTag id="allJobs" lng={this.props.i18n.language}></InfoTag>
                    </th>
                    <th>
                      <Trans i18nKey="applications.SCORE" />
                      &nbsp;
                      <InfoTag id="jobScore" lng={this.props.i18n.language}></InfoTag>
                    </th>
                    <th>
                      <Trans i18nKey="common.ADDED" />
                    </th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {this.props.applications.map((application, index) => (
                    <tr key={index}>
                      <td className="text-center">
                        {!this.props.forSpecificApplicant && <b>{this.props.counting + index + 1}</b>}&nbsp;
                        {this.props.forSpecificApplicant && <b>{index + 1}</b>}&nbsp;
                        {application.isNew && (
                          <div className="badge badge-warning">
                            <em id={'iconForNewApplicant'} className="fa fa-star">
                              <Trans i18nKey="applications.NEW" />
                            </em>
                          </div>
                        )}
                      </td>
                      <td hidden>{application.applicationId}</td>
                      {/* {!this.props.forSpecificApplicant ?  ( */}
                      <td>
                        <a href={`/applications/details?applicantId=${application.applicantId}&tab=applicationDetails`}>
                          {application.applicantFirstName}
                          &nbsp;
                          {application.applicantLastName}
                        </a>
                        <br />
                        {application.email}
                        <Row>
                          <Col className="col-auto">
                            <Trans i18nKey="jobs.ASSIGNED_TO" />
                            <Button color="primary" onClick={() => this.toggle(application)} outline size="xs">
                              <strong>{application.assignedTo}</strong>
                            </Button>
                          </Col>
                        </Row>
                      </td>
                      <td className="text-center">
                        <Row>
                          <Col>
                            <ApplicationButtons
                              application={application}
                              onStatusRefresh={() => this.props.refreshStatus()}
                            />
                          </Col>
                        </Row>
                      </td>
                      <td>
                        {application.jobTitle === 'Empty(No Job)' ? (
                          <p>
                            <Trans i18nKey="applications.EMPTY_NO_JOB" />
                          </p>
                        ) : (
                          <div>
                            <a href={`/jobs/${application.jobId}`}>{application.jobTitle}</a>
                          </div>
                        )}
                      </td>
                      <td>
                        {application.cv && (
                          <em
                            id={`newspaper-${index}`}
                            className="fa-2x mr-2 fas fa-newspaper far icon-hover-effect-no-color"
                            onClick={() => {
                              downloadDocument(
                                application.cv,
                                application.applicantFirstName + '_' + application.applicantLastName + '_CV',
                                t
                              );
                            }}
                          >
                            <UncontrolledTooltip
                              delay={{ show: 300, hide: 0 }}
                              placement="left"
                              target={`newspaper-${index}`}
                            >
                              <Trans i18nKey="applicants.OPEN_CV" />
                            </UncontrolledTooltip>
                          </em>
                        )}
                      </td>
                      <td className="text-center">
                        {composeApplicationType(application, t, this.props.i18n.language)}
                      </td>
                      <td>{application.jobField}</td>
                      <td className="text-center">
                        <div id={`jobType-${index}`} className={utils.getBadgeColor(application.jobType)}>
                          {utils.translateJobType(application.jobType)}
                        </div>
                        <UncontrolledTooltip
                          delay={{ show: 300, hide: 0 }}
                          placement="right"
                          target={`jobType-${index}`}
                        >
                          {application.jobType === 'Open'
                            ? HelpMessages.getOpenJobsText(this.props.i18n.language)
                            : HelpMessages.getBoundedJobsText(this.props.i18n.language)}
                        </UncontrolledTooltip>
                      </td>
                      <td>
                        {application.maxScore > 0 &&
                        !isNaN(utils.calculatePercentage(application.scoreCombined, application.maxScore)) ? (
                          renderSuccessPercentage(application, 'small')
                        ) : (
                          <div className="text-warning text-center" id={`infoNoCompetences-${index}`}>
                            <em className="fa-2x fas fa-question-circle far icon-hover-effect-no-color"></em>
                            <UncontrolledTooltip
                              className="text-warning"
                              delay={{ show: 250, hide: 0 }}
                              placement="left"
                              target={`infoNoCompetences-${index}`}
                            >
                              {HelpMessages.getCantCalculateScoreText(this.props.i18n.language)}
                            </UncontrolledTooltip>
                          </div>
                        )}
                      </td>
                      <td>
                        {moment.utc(application.created).format(basicDateFormat)}
                        <br />({moment.utc(application.created).fromNow()})
                      </td>
                      <td className="text-center">
                        <em
                          id={`eyeButton-${index}`}
                          style={{ cursor: 'pointer' }}
                          className="fa-2x mr-2 fas fa-eye far icon-hover-effect-no-color"
                          onClick={() => this.goToApplication(application)}
                        >
                          <UncontrolledTooltip
                            delay={{ show: 300, hide: 0 }}
                            placement="left"
                            target={`eyeButton-${index}`}
                          >
                            <Trans i18nKey="common.DETAILS" />
                          </UncontrolledTooltip>
                        </em>
                        {application.applicationStatus !== 'Deleted' && (
                          <em
                            id={`deleteButton-${index}`}
                            style={{ cursor: 'pointer' }}
                            className="fa-2x mr-2 fas fa-trash far icon-hover-effect-no-color"
                            onClick={() => this.deleteApplication(application)}
                          >
                            <UncontrolledTooltip
                              delay={{ show: 300, hide: 0 }}
                              placement="left"
                              target={`deleteButton-${index}`}
                            >
                              <Trans i18nKey="common.DELETE" />
                            </UncontrolledTooltip>
                          </em>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          </>
        ) : (
          <Alert color="success">
            <em id="noApplicationsYetInfo" className="fa-x mr-2 icon-info">
              <Trans i18nKey="applications.NO_APPLICATIONS_YET_INFO" />
            </em>
          </Alert>
        )}
      </>
    );
  }
}

export default withRouter(withTranslation('translations')(ApplicationsTable));
